export function getCookie(name) {
  var value = '; ' + document.cookie;
  var parts = value.split('; ' + name + '=');
  if (parts.length == 2) return parts.pop().split(';').shift();
  return false;
}

export function deleteCookie(name) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export function setCookie(cname, cvalue, exdays, withPath) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  var path = withPath ? window.location.pathname : '/';
  document.cookie = cname + '=' + cvalue + '; ' + expires + ';path=' + path;
}

export function setGameRatingCookie(value, gameId) {
  const key = 'gameRating',
    ratings = getCookie(key) ? JSON.parse(getCookie(key)) : {};
  ratings[gameId] = value;
  const cvalue = JSON.stringify(ratings);
  setCookie(key, cvalue, 360);
}

export function getGameRatingCookie(gameId) {
  const key = 'gameRating',
    ratings = getCookie(key) ? JSON.parse(getCookie(key)) : {};
  return ratings[gameId] || false;
}
